var map = {
	"./en/Discount.png": "8477",
	"./en/DiscountA.png": "b885",
	"./en/advertise.png": "9fcf",
	"./en/bannerLoading1.png": "c7f0",
	"./en/bottom-icon1.png": "2eea",
	"./en/container_mobile_img.png": "bfef",
	"./en/cupLeft.png": "fd91",
	"./en/cupRight.png": "f6c9",
	"./en/deposit.png": "101a",
	"./en/depositA.png": "4173",
	"./en/dze/1.png": "8432",
	"./en/dze/2.png": "e7f0",
	"./en/dze/3.png": "7360",
	"./en/dze/4.png": "f071",
	"./en/dze/5.png": "becb",
	"./en/dze/6.png": "3713",
	"./en/dze/7.png": "cc8c",
	"./en/dze/8.png": "2c81",
	"./en/dze/Hotline-a.png": "6c82",
	"./en/dze/Hotline.png": "bb6c",
	"./en/dze/email-a.png": "1d95",
	"./en/dze/email.png": "3494",
	"./en/dze/fb-a.png": "2700",
	"./en/dze/fb.png": "30b9",
	"./en/dze/mosaicGold1.png": "4d6b",
	"./en/dze/mosaicGold1Hover.png": "843e",
	"./en/dze/mosaicGold2.png": "e5a8",
	"./en/dze/mosaicGold2Hover.png": "3165",
	"./en/dze/rebate-active.png": "d478",
	"./en/dze/rebate-normal.png": "e4d8",
	"./en/dze/tg-a.png": "d3ec",
	"./en/dze/tg.png": "c598",
	"./en/dze/yq-a.png": "2f52",
	"./en/dze/yq.png": "2701",
	"./en/dze/zalo-a.png": "ec5a",
	"./en/dze/zalo.png": "e6ef",
	"./en/flag.svg": "7c86",
	"./en/listbg1.jpg": "a16a",
	"./en/listbg2.jpg": "e7fd",
	"./en/listbg3.jpg": "0f6e",
	"./en/listbg4.jpg": "55e9",
	"./en/listbg5.jpg": "1002",
	"./en/listbg6.jpg": "2d77",
	"./en/listbg7.jpg": "6f18",
	"./en/listbg8.jpg": "6aa1",
	"./en/rightIcon.png": "0bcc",
	"./en/title_promotions.jpg": "cf86",
	"./en/top-list-left1.png": "fffe",
	"./en/top-list-left2.png": "c580",
	"./en/top-list-left3.png": "7642",
	"./en/top-list-left4.png": "26cb",
	"./en/top-list-left5.png": "4421",
	"./en/top-list-left6.png": "059e",
	"./en/top-list-left7.png": "1d05",
	"./pt/Discount.png": "9c5f",
	"./pt/DiscountA.png": "7c94",
	"./pt/Game_49220.png": "7ece",
	"./pt/advertise.png": "11b7",
	"./pt/bannerLoading1.png": "7cfe",
	"./pt/bottom-icon1.png": "d7ff",
	"./pt/cupLeft.png": "7915",
	"./pt/cupRight.png": "55b6",
	"./pt/deposit.png": "0312",
	"./pt/depositA.png": "3cfb",
	"./pt/dze/1.png": "08f6",
	"./pt/dze/2.png": "9209",
	"./pt/dze/3.png": "7bcc",
	"./pt/dze/4.png": "3b3d",
	"./pt/dze/5.png": "9770",
	"./pt/dze/6.png": "6451",
	"./pt/dze/7.png": "17e0",
	"./pt/dze/8.png": "4ad3",
	"./pt/dze/Hotline-a.png": "7288",
	"./pt/dze/Hotline.png": "12ae",
	"./pt/dze/email-a.png": "52ef",
	"./pt/dze/email.png": "933c",
	"./pt/dze/fb-1.png": "ac1e",
	"./pt/dze/fb-a.png": "2416",
	"./pt/dze/fb.png": "cdeb",
	"./pt/dze/mosaicGold1.png": "1073",
	"./pt/dze/mosaicGold1Hover.png": "f0b8",
	"./pt/dze/mosaicGold2.png": "0f1b",
	"./pt/dze/mosaicGold2Hover.png": "6c01",
	"./pt/dze/rebate-active.png": "586e",
	"./pt/dze/rebate-normal.png": "ef58",
	"./pt/dze/telegram-1.png": "78df",
	"./pt/dze/telegram.png": "fae3",
	"./pt/dze/tg-a.png": "2969",
	"./pt/dze/tg.png": "f119",
	"./pt/dze/yq-a.png": "27a8",
	"./pt/dze/yq.png": "261f",
	"./pt/dze/zalo-a.png": "c4e7",
	"./pt/dze/zalo.png": "5408",
	"./pt/flag.svg": "10c5",
	"./pt/hot_logo.png": "2f1e",
	"./pt/listbg1.jpg": "92de",
	"./pt/listbg2.jpg": "c2e8",
	"./pt/listbg3.jpg": "ee21",
	"./pt/listbg4.jpg": "cb51",
	"./pt/listbg5.jpg": "a828",
	"./pt/listbg6.jpg": "fb64",
	"./pt/listbg7.jpg": "a233",
	"./pt/listbg8.jpg": "af5d",
	"./pt/rightIcon.png": "189c",
	"./pt/title_promotions.jpg": "077c",
	"./pt/top-list-left1.png": "1a66",
	"./pt/top-list-left2.png": "4acb",
	"./pt/top-list-left3.png": "67f4",
	"./pt/top-list-left4.png": "0792",
	"./pt/top-list-left5.png": "e3ab",
	"./pt/top-list-left6.png": "2352",
	"./pt/top-list-left7.png": "86b9",
	"./vi/Discount.png": "3cd3",
	"./vi/DiscountA.png": "7fd4",
	"./vi/advertise.png": "b8d4",
	"./vi/bannerLoading1.png": "1cc7",
	"./vi/bottom-icon1.png": "1822",
	"./vi/bottom-icon2.png": "adfa",
	"./vi/container_mobile_img.png": "d928",
	"./vi/cupLeft.png": "10c8",
	"./vi/cupRight.png": "3d69",
	"./vi/deposit.png": "9246",
	"./vi/depositA.png": "19f5",
	"./vi/dze.zip": "1195",
	"./vi/dze/1.png": "5987",
	"./vi/dze/2.png": "4db8",
	"./vi/dze/3.png": "c72c",
	"./vi/dze/4.png": "8574",
	"./vi/dze/5.png": "a561",
	"./vi/dze/6.png": "da64",
	"./vi/dze/7.png": "dd06",
	"./vi/dze/8.png": "2003",
	"./vi/dze/Hotline-a.png": "0b69",
	"./vi/dze/Hotline.png": "6bc6",
	"./vi/dze/email-a.png": "cece",
	"./vi/dze/email.png": "3974",
	"./vi/dze/fb-1.png": "02bf",
	"./vi/dze/fb-a.png": "91c3",
	"./vi/dze/fb.png": "40f7",
	"./vi/dze/jun88/1.png": "442b",
	"./vi/dze/jun88/2.png": "572b",
	"./vi/dze/jun88/3.png": "e899",
	"./vi/dze/jun88/4.png": "883a",
	"./vi/dze/jun88/5.png": "ee19",
	"./vi/dze/jun88/6.png": "dce2",
	"./vi/dze/jun88/7.png": "130a",
	"./vi/dze/jun88/8.png": "c9bf",
	"./vi/dze/jun88/Hotline-a.png": "b0f2",
	"./vi/dze/jun88/Hotline.png": "0e79",
	"./vi/dze/jun88/email-a.png": "7d0e",
	"./vi/dze/jun88/email.png": "aa88",
	"./vi/dze/jun88/fb-a.png": "186c",
	"./vi/dze/jun88/fb.png": "78f8",
	"./vi/dze/jun88/mosaicGold1.png": "d52d",
	"./vi/dze/jun88/mosaicGold1Hover.png": "7379",
	"./vi/dze/jun88/mosaicGold2.png": "00a7",
	"./vi/dze/jun88/mosaicGold2Hover.png": "f758",
	"./vi/dze/jun88/rebate-active.png": "d418",
	"./vi/dze/jun88/rebate-normal.png": "b696",
	"./vi/dze/jun88/tg-a.png": "2805",
	"./vi/dze/jun88/tg.png": "7f0a",
	"./vi/dze/jun88/yq-a.png": "36e8",
	"./vi/dze/jun88/yq.png": "7e90",
	"./vi/dze/jun88/zalo-a.png": "ae41",
	"./vi/dze/jun88/zalo.png": "6c36",
	"./vi/dze/lixibao.png": "943b",
	"./vi/dze/lixibao1.png": "a3cd",
	"./vi/dze/mosaicGold1.png": "f586",
	"./vi/dze/mosaicGold1Hover.png": "281a",
	"./vi/dze/mosaicGold2.png": "cf75",
	"./vi/dze/mosaicGold2Hover.png": "2d59",
	"./vi/dze/rebate-active.png": "ce16",
	"./vi/dze/rebate-normal.png": "a4dc",
	"./vi/dze/telegram-1.png": "ccec",
	"./vi/dze/telegram.png": "623c",
	"./vi/dze/tg-a.png": "4b25",
	"./vi/dze/tg.png": "367a",
	"./vi/dze/yq-a.png": "4f18",
	"./vi/dze/yq.png": "6c26",
	"./vi/dze/zalo-a.png": "5023",
	"./vi/dze/zalo.png": "144b",
	"./vi/flag.svg": "2a0c",
	"./vi/listbg1.jpg": "96ee",
	"./vi/listbg2.jpg": "2138",
	"./vi/listbg3.jpg": "6ecc",
	"./vi/listbg4.jpg": "4cde",
	"./vi/listbg5.jpg": "5d0a",
	"./vi/listbg6.jpg": "f9c7",
	"./vi/listbg7.jpg": "9ae1",
	"./vi/listbg8.jpg": "2008",
	"./vi/logo-icon.png": "131b",
	"./vi/rightIcon.png": "e28e",
	"./vi/title_promotions.jpg": "cdc9",
	"./vi/top-list-left1.png": "2784",
	"./vi/top-list-left2.png": "da41",
	"./vi/top-list-left3.png": "4939",
	"./vi/top-list-left4.png": "e83d",
	"./vi/top-list-left5.png": "2b0d",
	"./vi/top-list-left6.png": "e844",
	"./vi/top-list-left7.png": "432f",
	"./zh_CN/Discount.png": "8049",
	"./zh_CN/DiscountA.png": "27c8",
	"./zh_CN/advertise.png": "1475",
	"./zh_CN/bannerLoading1.png": "6d8b",
	"./zh_CN/bottom-icon1.png": "18ed",
	"./zh_CN/cupLeft.png": "2953",
	"./zh_CN/cupRight.png": "1082",
	"./zh_CN/deposit.png": "ee2e",
	"./zh_CN/depositA.png": "4aa0",
	"./zh_CN/dze/1.png": "3f54",
	"./zh_CN/dze/2.png": "036d",
	"./zh_CN/dze/3.png": "de26",
	"./zh_CN/dze/4.png": "c35e",
	"./zh_CN/dze/5.png": "c07f",
	"./zh_CN/dze/6.png": "b87a",
	"./zh_CN/dze/7.png": "d343",
	"./zh_CN/dze/8.png": "f4f7",
	"./zh_CN/dze/Hotline-a.png": "fbfe",
	"./zh_CN/dze/Hotline.png": "4024",
	"./zh_CN/dze/email-a.png": "1d48",
	"./zh_CN/dze/email.png": "b034",
	"./zh_CN/dze/fb-a.png": "d726",
	"./zh_CN/dze/fb.png": "cf76",
	"./zh_CN/dze/mosaicGold1.png": "084f",
	"./zh_CN/dze/mosaicGold1Hover.png": "f6bb",
	"./zh_CN/dze/mosaicGold2.png": "b5ac",
	"./zh_CN/dze/mosaicGold2Hover.png": "245d",
	"./zh_CN/dze/rebate-active.png": "ab49",
	"./zh_CN/dze/rebate-normal.png": "91fc",
	"./zh_CN/dze/tg-a.png": "593d",
	"./zh_CN/dze/tg.png": "dadc",
	"./zh_CN/dze/yq-a.png": "032b",
	"./zh_CN/dze/yq.png": "4622",
	"./zh_CN/dze/zalo-a.png": "4b6b",
	"./zh_CN/dze/zalo.png": "63fb",
	"./zh_CN/flag.svg": "2711",
	"./zh_CN/funwcontainer_mobile_img.png": "8d04",
	"./zh_CN/listbg1.jpg": "0016",
	"./zh_CN/listbg2.jpg": "21df",
	"./zh_CN/listbg3.jpg": "57d4",
	"./zh_CN/listbg4.jpg": "756d",
	"./zh_CN/listbg5.jpg": "9dba",
	"./zh_CN/listbg6.jpg": "033c",
	"./zh_CN/listbg7.jpg": "0e83",
	"./zh_CN/listbg8.jpg": "a1ca",
	"./zh_CN/rightIcon.png": "7b41",
	"./zh_CN/title_promotions.jpg": "198c",
	"./zh_CN/top-list-left1.png": "f4ff",
	"./zh_CN/top-list-left2.png": "fa45",
	"./zh_CN/top-list-left3.png": "848b",
	"./zh_CN/top-list-left4.png": "a518",
	"./zh_CN/top-list-left5.png": "688a",
	"./zh_CN/top-list-left6.png": "1144",
	"./zh_CN/top-list-left7.png": "e2f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "82c8";